function CategoryCard({ category, onClick }) {
  return (
    <div 
      className="category-card" 
      onClick={onClick} 
      style={{ cursor: 'pointer' }}
    >
      <img src={category.image} alt={category.name} className="category-img" />
      <div className="category-overlay">
        <span className="category-title">{category.name}</span>
      </div>
    </div>
  );
}

export default CategoryCard;